import React, {useEffect} from 'react';
import {makeStyles} from 'tss-react/mui';
import {useParams} from 'react-router-dom';
import {useIntl} from 'react-intl';
import CircularProgress from '@mui/material/CircularProgress';
import {
  DocumentCollectionProvider,
  useDocumentCollection,
} from './context/DocumentCollectionContext';
import {SCREENS} from './constants/documentCollection';
import {fetchPageModel} from './api/documentCollectionApi';
import MinimalHeader from './components/MinimalHeader';
import AuthScreen from './screens/AuthScreen';
import InvalidLinkScreen from './screens/InvalidLinkScreen';
import ErrorScreen from './screens/ErrorScreen';
import WelcomeScreen from './screens/WelcomeScreen';
import UploadScreen from './screens/UploadScreen';
import HarHaBituchScreen from './screens/HarHaBituchScreen';
import SuccessScreen from './screens/SuccessScreen';

const useStyles = makeStyles()((theme) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.palette.background.paper,
    direction: 'rtl',
    textAlign: 'right',
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    flexDirection: 'column',
    gap: 16,
  },
  loadingText: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.secondary,
  },
}));

const DocumentCollectionInner = () => {
  const {classes} = useStyles();
  const {shortLinkKey} = useParams();
  const intl = useIntl();
  const {currentScreen, setTokenData, setError} = useDocumentCollection();

  useEffect(() => {
    const init = async () => {
      try {
        const data = await fetchPageModel(shortLinkKey);
        setTokenData(shortLinkKey, data);
      } catch (err) {
        setError(err.message || 'Failed to load page');
      }
    };
    init();
  }, [shortLinkKey, setTokenData, setError]);

  const renderScreen = () => {
    switch (currentScreen) {
    case SCREENS.LOADING:
      return (
        <div className={classes.loadingContainer}>
          <CircularProgress size={40} />
          <span className={classes.loadingText}>
            {intl.formatMessage({id: 'docCollection.loading'})}
          </span>
        </div>
      );
    case SCREENS.AUTH:
      return <AuthScreen />;
    case SCREENS.EXPIRED:
      return <InvalidLinkScreen variant='expired' />;
    case SCREENS.INVALID:
      return <InvalidLinkScreen variant='invalid' />;
    case SCREENS.ERROR:
      return <ErrorScreen />;
    case SCREENS.WELCOME:
      return <WelcomeScreen />;
    case SCREENS.UPLOAD:
      return <UploadScreen />;
    case SCREENS.HAR_HABITUCH:
      return <HarHaBituchScreen />;
    case SCREENS.SUCCESS:
      return <SuccessScreen />;
    default:
      return <ErrorScreen />;
    }
  };

  return (
    <div className={classes.root} dir='rtl'>
      <MinimalHeader />
      {renderScreen()}
    </div>
  );
};

const DocumentCollectionPage = () => (
  <DocumentCollectionProvider>
    <DocumentCollectionInner />
  </DocumentCollectionProvider>
);

export default DocumentCollectionPage;
